var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login',{ref:"login",attrs:{"emailEnabled":false,"is-loading":_vm.isLoading,"is-dark":true,"forgot-password-route":"forgotpass","register-route":"register","solo":true,"outlined":false,"rememberMeEnabled":false,"icon-enabled":true},on:{"login":_vm.onLogin}})
}
var staticRenderFns = []

export { render, staticRenderFns }